import { BedroomType } from '../types';
import type { SelectOption } from '~/components/forms/types.d.ts';

export const bedroomsBathroomsOptions: SelectOption<number>[] = [
  {
    name: '1',
    value: 1,
  },
  {
    name: '2',
    value: 2,
  },
  {
    name: '3',
    value: 3,
  },
  {
    name: '4',
    value: 4,
  },
  {
    name: '5',
    value: 5,
  },
  {
    name: '6',
    value: 6,
  },
  {
    name: '7',
    value: 7,
  },
  {
    name: '8',
    value: 8,
  },
  {
    name: '9',
    value: 9,
  },
  {
    name: '10',
    value: 10,
  },
  {
    name: '11',
    value: 11,
  },
  {
    name: '12',
    value: 12,
  },
  {
    name: '13',
    value: 13,
  },
  {
    name: '14',
    value: 14,
  },
  {
    name: '15',
    value: 15,
  },
];

export const BedroomLabels = {
  [BedroomType.SINGLE]: 'Single',
  [BedroomType.DOUBLE]: 'Double',
  [BedroomType.SINGLE_ENSUITE]: 'Single ensuite',
  [BedroomType.DOUBLE_ENSUITE]: 'Double ensuite',
  [BedroomType.ALREADY_LET]: 'Already let',
};

export const BedroomTypeOptions = computed<SelectOption<BedroomType>[]>(() => {
  const options: SelectOption<BedroomType>[] = [];

  const typeIndexes = Object.values(BedroomType).filter(
    (enumValue: string | number) => typeof enumValue === 'number',
  );

  for (const type of typeIndexes) {
    options.push({
      name: BedroomLabels[type as keyof typeof BedroomLabels],
      value: type as BedroomType,
    });
  }
  return options;
});

export const PerformanceGraphSize = {
  width: 816,
  height: 212,
};

export const PROPERTY_BOOST_24_HOUR_MESSAGE: string =
  'Properties can only be boosted once every 24 hours';

export const MODAL_DELETE_UNIT = 'modal_delete_unit';

export const MODAL_TYPES = [MODAL_DELETE_UNIT];

export const ADVERT_TYPE_BTR =
  'btr' as App.Domain.Properties.Enums.AdvertType.btr;

export const ADVERT_TYPE_HMO =
  'hmo' as App.Domain.Properties.Enums.AdvertType.hmo;

export const ADVERT_TYPE_SPARE_ROOM =
  'spare_room' as App.Domain.Properties.Enums.AdvertType.spare_room;

export const UNIT_MEDIA_TYPES = {
  IMAGE: 'image',
  FLOORPLAN: 'floorplan',
} as const;
